import { IdentificationDocSearchDto } from '@app/api2/api';
import * as Yup from 'yup';

export const IdentificationSearchSchema: Yup.SchemaOf<IdentificationDocSearchDto> = Yup.object({
    discriminator: Yup.string().required(),
    operator: Yup.string().optional(),
    idNumber: Yup.string().optional().test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { idType, country, stateOfIssuance } = this.parent;
            return !!value || !!idType || !!country || !!stateOfIssuance;
        }
    ),
    idType: Yup.number().required().test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { idNumber, country, stateOfIssuance } = this.parent;
            return !!value || !!idNumber || !!country || !!stateOfIssuance;
        }
    ),
    country: Yup.string().optional().test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { idNumber, idType, stateOfIssuance } = this.parent;
            return !!value || !!idNumber || !!idType || !!stateOfIssuance;
        }
    ),
    stateOfIssuance: Yup.string().optional().test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { idNumber, idType, country } = this.parent;
            return !!value || !!idNumber || !!idType || !!country;
        }
    ),
});
